var LocalStorageService = /** @class */ (function () {
    function LocalStorageService() {
    }
    LocalStorageService.prototype.setItem = function (key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    };
    LocalStorageService.prototype.getItem = function (key) {
        var data = localStorage.getItem(key);
        if (data !== null) {
            return JSON.parse(data);
        }
        return null;
    };
    LocalStorageService.prototype.clear = function () {
        localStorage.clear();
    };
    return LocalStorageService;
}());
export default new LocalStorageService();
